import * as React from 'react';
import { initI18n } from '@websky/core/src/utils';
import Notification from '@websky/core/src/Notification/components/Notification';
import * as theme from './Notification.css';
initI18n('Service');
const CheckinNotification = props => {
    return React.createElement(Notification, Object.assign({}, props, { className: theme.wrapper }));
};
export default CheckinNotification;
